/*
 * Copyright (c) 2021 LucidResolutions LLC. All rights reserved.
 */

import APIBaseService from "./api.base.service";

const url = "/v1/payments"
class PaymentService extends APIBaseService {
    constructor() {
        super();
        this.usePathPrefix(url)
    }

    async buttons(){
        let result = await this.request(this.post('stripe-buttons/', {}, {maxRetries: 3}), 200)
        return result.data
    }

    async checkOutStatus(id: any) {
        let result = await this.request(this.get(`checkout-status/${id}`, {maxRetries: 1}), 200)
        return result.data
    }

    async getBillingPortal() {
        let returnURL = encodeURIComponent(window.location.toString())
        let result = await this.request(this.get(`billing-portal/?return_url=${returnURL}`, {maxRetries: 1}), 200)
        return result.data
    }
}

export default PaymentService
